import { initialState } from "./initialState";
import {
  CLEAR_BATCH_DATA_ON_PRODUCT_CHANGE,
  FETCH_BATCH_LIST_FOR_REPORT,
  FETCH_PARAMETER_LIST,
  FETCH_REPORT_DETAILS_FOR_EDIT,
  FETCH_REPORT_FILE,
  FETCH_REPORTS_LIST,
  GENERATE_REPORT,
  RESET_GENERATE_REPORT,
} from "./types";

const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORTS_LIST:
      return { ...state, reportsList: action.payload };

    case GENERATE_REPORT:
      return { ...state, generatedReport: action.payload };

    case RESET_GENERATE_REPORT:
      return { ...state, generatedReport: null };

    case FETCH_PARAMETER_LIST:
      return { ...state, parameterList: action.payload };

    case FETCH_BATCH_LIST_FOR_REPORT:
      return {
        ...state,
        filteredBatchListForReport: action.payload,
      };
    // case FETCH_REPORT_FILE:
    //   return {
    //     ...state,
    //     fileData: action.payload,
    //   };
    case FETCH_REPORT_DETAILS_FOR_EDIT:
      return {
        ...state,
        reportData: action.payload,
      };

    case CLEAR_BATCH_DATA_ON_PRODUCT_CHANGE:
      return { ...state, shouldClear: action.payload };

    default:
      return state;
  }
};

export default reportsReducer;
